import * as React from "react";
const IconSthethoscope = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M55.4 1.8H49c-1.2 0-2.2 1-2.2 2.2v2.5c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2v-.3h3.1v17.4c0 6.2-5 11.2-11.2 11.2H42c-6.2 0-11.2-5-11.2-11.2V6.2h3.1v.3c0 1.2 1 2.2 2.2 2.2s2.2-1 2.2-2.2V4c0-1.2-1-2.2-2.2-2.2h-6.4c-1.9 0-3.5 1.6-3.5 3.5v18.4c0 8.5 6.8 15.4 15.3 15.7V52c0 3.2-2.4 5.8-5.4 5.8H21.4c-3.2 0-5.8-2.6-5.8-5.8v-8.2c3.6-1 6.3-4.2 6.3-8.1 0-4.6-3.8-8.4-8.4-8.4s-8.4 3.8-8.4 8.4c0 3.8 2.6 7.1 6.1 8.1V52c0 5.7 4.6 10.3 10.3 10.3h14.8c5.5 0 9.9-4.6 9.9-10.3V39c7.2-1.4 12.7-7.8 12.7-15.4V5.3c0-2-1.6-3.5-3.5-3.5M9.6 35.6c0-2.2 1.8-3.9 3.9-3.9s3.9 1.8 3.9 3.9c0 2.2-1.8 3.9-3.9 3.9s-3.9-1.7-3.9-3.9" />
  </svg>
);
export default IconSthethoscope;
